import * as React from 'react';
import { Header1 } from '@cian/ui-kit/typography';

import { Link } from '../Link';

import * as styles from './styles.css';

interface IOffersHeaderProps {
  fromDeveloperPropsCountDisplay: string;
  fromDeveloperPropsCountUrl: string;
  newbuildingName: string;
  onLinkClick(): void;
  salesStartInfo?: React.ReactNode;
}

export function OffersHeader({
  fromDeveloperPropsCountDisplay,
  fromDeveloperPropsCountUrl,
  newbuildingName,
  onLinkClick,
  salesStartInfo,
}: IOffersHeaderProps) {
  return (
    <div data-nav-tab="filter/Квартиры" id="filter" className={styles['nav_container']}>
      <div className={styles['container']}>
        <Header1 as="h2" color="black_100">
          {fromDeveloperPropsCountDisplay ? (
            <Link url={fromDeveloperPropsCountUrl} target="blank" onClick={onLinkClick}>
              {fromDeveloperPropsCountDisplay}
            </Link>
          ) : (
            'Квартиры и апартаменты'
          )}
          {` в ${newbuildingName}`}
        </Header1>
        {salesStartInfo && <div className={styles['sales-start']}>{salesStartInfo}</div>}
      </div>
    </div>
  );
}
